module.exports = __webpack_public_path__ + "img/2023_jeep-renegade.137b4ccd.png";